import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { parseInternalReturnUrl } from '../utils/internal-return-url';

/**
 * Exige sesión válida: token presente y JWT no caducado.
 * Sin token → `/login` (con `returnUrl` si aplica).
 * Token caducado → limpia sesión y `/login?expired=true`.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const returnUrl = parseInternalReturnUrl(state.url) ?? undefined;

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login'], {
      queryParams: returnUrl ? { returnUrl } : {},
    });
  }

  if (auth.isTokenExpired()) {
    auth.logout({ skipNavigation: true });
    return router.createUrlTree(['/login'], {
      queryParams: {
        expired: 'true',
        ...(returnUrl ? { returnUrl } : {}),
      },
    });
  }

  return true;
};
